import React from 'react';
import img1 from '../assets/1.jpg';
import img2 from '../assets/2.jpg';
import img3 from '../assets/3.jpg';
import img4 from '../assets/4.jpg';
import location from '../assets/map.png';
import tel from '../assets/tel.png';
import timer from '../assets/timer.png';
import email from '../assets/email.png';
import fb from '../assets/facebook.png';
import ig from '../assets/instagram.png';
import ta from '../assets/tripadvisor.png';
import './Home.css';

import './Nav.css';
function Home() {
  return (
  <div className="Home">
         
        <div className="Text" >
            <h1>
              Injera Restaurant Milano
             </h1>
          </div>
        <div className="Carousels">
           <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel">
              <div class="carousel-indicators">
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 4"></button>
                </div>
              <div class="carousel-inner">
                  <div class="carousel-item active">
                      <img src={img1} class="d-block w-100 md" alt="..."></img>
                   </div>
                  <div class="carousel-item">
                    <img src={img2} class="d-block w-100 md" alt="..."></img>
                  </div>
                  <div class="carousel-item">
                    <img src={img3} class="d-block w-100 md" alt="..."></img>
                  </div>
                  <div class="carousel-item">
                    <img src={img4} class="d-block w-100 md" alt="..."></img>
                  </div>
             </div>
            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
            </button>
           </div>
     </div>
     <div className="About">
           <h1 class="ab">About Us</h1>
           <p class="paragraph">Restaurant with Eritrea and Ethiopian cuisine a stone's throw from the Central Station and the subway.<br/>Among our specialties are vegetarian dishes (zighinì) and meat (zighinì, kifto, gored, spriss).<br/> Cozy place, ideal for business lunches and dinners with friends.</p>
     </div>   
     <div className="Maps">
    <h1 className="location">Location</h1>
     <iframe src={"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2797.6305657443254!2d9.19989011474086!3d45.47724544059523!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4786c6c7a276cbb9%3A0xf093146c6c665e27!2sInjera!5e0!3m2!1sen!2spl!4v1633168263606!5m2!1sen!2spl"} width="600" height="450"  allowfullscreen="" loading="lazy"></iframe>
     </div>
     <div className="contacts">
     <h1>Contact </h1>
     <div className="cont" id="contact">
     <div className="left">
       <div className="location">
       <img className="loc" src={location}></img> 
       <p>Via Castaldi 19 Milan</p>
       </div>
     
      <div className="tel">
      <img className="loc" src={tel}></img>
      <p>02 36633530</p>
      </div>
      <div className="email">
      <img className="loc" src={email}></img>
      <p>info@ristoranteinjera.it</p>
      </div>
      <div className="timer">
      <img className="loc" src={timer}></img>
      <p> Tuesday - Sunday : 11:30 - 23:30<br/>Monday : Closed</p>
      </div>
      
       </div>
       <div className="right">
        <div className="text"><p>Follow us</p></div>   
            
            <div className="image">
              <a href="https://www.facebook.com/YONASINJERA/"><img target="_blank" src={fb} className="sm"></img></a>
               
              <a href="https://www.instagram.com/ristoranteinjera/" target="_blank">  <img src={ig} className="sm"></img></a>
              <a href="https://www.tripadvisor.it/Restaurant_Review-g187849-d11905713-Reviews-Ristorante_Injera-Milan_Lombardy.html" target="_blank"> <img src={ta} className="sm"></img></a>
            </div>
       </div>
     </div>
      
        
     </div>
</div>
         
  );
}
export default Home;